import { useEffect, useState } from "react";
import { endpoint } from "../../assets/api/endpoint";
import { useSelector } from "react-redux";
import { apiHandler } from "../../assets/api";
import "../../assets/css/Minor.css";
import CustomButton from "../../components/CustomButton";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const MinorPrivacy = () => {
    const { accessToken , minorAccountList } = useSelector((state) => state.loginInfo);
    const [accountList, setAccountList] = useState([]);
    const [selectedAccount, setSelectedAccount] = useState("");
    const navigate = useNavigate()
    const [permissions, setPermissions] = useState({
        sameAgeGroup: false,
        allowGameCreation: false,
        allowChatting: false,
    });

    const checkboxOptions = [
        { key: 'sameAgeGroup', label: 'Play with Same age group', disabled: true },
        { key: 'allowGameCreation', label: 'Allowed Game Creation', disabled: false },
        { key: 'allowChatting', label: 'Allowed Chatting', disabled: false },
    ];

    const fetchPermissions = async () => {
        try {
            const result = await apiHandler({
                url: `${endpoint.FETCH_PERMISSION}?minorId=${selectedAccount}`,
                method: "GET",
                authToken: accessToken?.accessToken,
            });
            if (result.data) {
                setPermissions({
                    sameAgeGroup: true,
                    allowGameCreation: result?.data?.gameCreateAllow ?? false,
                    allowChatting: result?.data?.chatAllow ?? false,
                });
            }
        } catch (error) {
            console.error("Error fetching account list:", error);
        }
    };

    useEffect(()=>{
        setAccountList(minorAccountList)
    },[minorAccountList])

    useEffect(() => {
        fetchPermissions();
    }, [selectedAccount])

    const handlePermission =async () => {
    
            try {
                const result = await apiHandler({
                    url: `${endpoint?.MINOR_PERMISSION}?id=${selectedAccount}&isCreateGame=${permissions?.allowGameCreation}&isChat=${permissions?.allowChatting}`,
                    method: "POST",
                    authToken: accessToken?.accessToken,
                });
                if (result.data) {
                    toast.success("Permission is allowed");
                    navigate('/profile')
                }
            } catch (error) {
                console.error("Error setting permissions:", error);
                toast.error("Something went wrong please try again");
            }
    };

    const handleCheckboxChange = (key) => {
        setPermissions((prev) => ({
            ...prev,
            [key]: !prev[key],
        }));
    };

    return (
        <div className="minor-privacy-container p-3 ms-4 me-4 mb-4 m-sm-0" style={{ height: 'auto'}}>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <div >
                    <h4 className="label-style mb-4">Select Minor Account For Permission</h4>
                    <select
                        className="dropdown-style"
                        value={selectedAccount}
                        onChange={(e) => setSelectedAccount(e.target.value)}
                    >
                        <option value="">All minor Account...</option>
                        {accountList?.map((account, index) => (
                            <option key={index} value={account.id} style={{ cursor: 'pointer' }}>
                                {account.name || `Account ${index + 1}`}
                            </option>
                        ))}
                    </select>
                </div>

                {selectedAccount && (
                    <div className="permission-card" style={{
                        marginTop: "30px",
                        padding: "20px",
                        border: "1.5px solid #ccc",
                        borderRadius: "10px",
                        backgroundColor: "#f9f9f9",
                    }}>
                        {checkboxOptions?.map(({ key, label, disabled }) => (
                            <label className="d-flex align-items-center " key={key} style={{ marginBottom: '10px', color: disabled ? '#aaa' : '#000' }}>
                                <input
                                    className="me-2"
                                    style={{ width: '20px', height: '20px', cursor: 'pointer' }}
                                    type="checkbox"
                                    checked={permissions[key]}
                                    disabled={disabled}
                                    onChange={() => !disabled && handleCheckboxChange(key)}
                                />{" "}
                                {label}
                            </label>
                        ))}
                    </div>
                )}

                <div style={{ marginTop: '30px' }}>
                    <CustomButton
                        buttonText={"Set Permission"}
                        className="border"
                        style={{
                            width: "100%",
                            height: "48px",
                            borderRadius: "12px",
                            background: "#006FFD",
                            color: "#FFFFFF",
                        }}
                        onClick={handlePermission}
                        disabled={!selectedAccount}
                    />
                </div>
            </div>
        </div>
    );
};

export default MinorPrivacy;
